import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LanguageToggle from './LanguageToggle';
import AppMenuBar from './AppMenuBar';

const GlobalControls = () => {
    const { user, initializing } = useAuth();
    const { pathname } = useLocation();
    if (initializing || pathname.startsWith('/play/')) return null;
    const isAuthPage = ['/login', '/register', '/forgot-password'].includes(pathname);
    const showAccountMenu = Boolean(user) && !isAuthPage;
    const isLobby = /^\/poker(?:\/[^/]+)?\/?$/.test(pathname) || /^\/shan9mee(?:\/[^/]+)?\/?$/.test(pathname)
        || /^\/[^/]+$/.test(pathname) && !isAuthPage && !['/account-settings', '/admin', '/test'].includes(pathname);
    return <AppMenuBar isLobby={isLobby} menuControl={showAccountMenu ? undefined : <LanguageToggle />} />;
};
export default GlobalControls;
